<template>
    <div id="modal-work-full" ref="modalWorkFull" class="dropdown-menu">
        <button class="uk-modal-close-full" type="button" @click="toggleModal"><i class="fa fa-times fa-5x" aria-hidden="true"></i></button>
        <div class="work-container uk-padding uk-margin-large-top">
            
            <h2 class="uk-heading-primary yellow uk-margin-bottom">Work</h2>
            
            <div class="work-container-overlay uk-grid-small uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-4@m uk-text-center" uk-grid>
                <portfolio-category-tile 
                    v-for="(category, i) in portfolioCategories" :key="i"
                    :name="category.name"
                    :slug="category.slug"
                    :href="`/work/${category.slug}`"
                    :color="category.color"
                    @hasClick="toggleOverlay">
                </portfolio-category-tile>
            </div>
        </div>
    </div>
</template>

<script>
import PortfolioCategoryTile from '@/components/PortfolioCategoryTile'
import UIkit from 'uikit'

export default {
    name: 'work',
    components: {
        PortfolioCategoryTile
    },
    computed: {
        menuFields () {
            if (this.$store.state.menus.loaded) {
                const menus = { ...this.$store.getters.menus }
                return menus['work'].fields.menuList
            }
            return null
        },
        portfolioCategories () {
            const categories = []
            if (this.menuFields) {
                this.menuFields.forEach(element => {
                    const obj = {
                        name: element.fields.categoryName ? element.fields.categoryName : '',
                        slug: element.fields.categorySlug ? element.fields.categorySlug : '',
                        color: element.fields.categoryColour ? element.fields.categoryColour.fields.colourSlug : '',
                        image: (element.fields.categoryImage) ? element.fields.categoryImage.fields.file.url : null
                    }
                    categories.push(obj)
                })
            }
            return categories
        }
    },
    created () {
        if (!this.$store.getters.portfolio.loaded) {
            this.$store.dispatch('getPortfolio')
        }
    },
    methods: {
        toggleOverlay () {
            let dropdown = this.$refs.modalWorkFull
            if (dropdown.classList.contains('active')) {
                dropdown.classList.remove('active')
            } else {
                dropdown.classList.add('active')
            }

            let overlay = document.querySelector('[data-overlay]')
            let body = document.querySelector('body')
            if (overlay.classList.contains('active')) {
                overlay.classList.remove('active')
                body.classList.remove('scroll-lock')
            } else {
                overlay.classList.add('active')
                body.classList.add('scroll-lock')
            }
        },
        toggleModal () {
            let dropdown = document.querySelector('#modal-work-full')
            if (dropdown.classList.contains('active')) {
                dropdown.classList.remove('active')
            } else {
                dropdown.classList.add('active')
            }

            let overlay = document.querySelector('[data-overlay]')
            let body = document.querySelector('body')
            if (overlay.classList.contains('active')) {
                overlay.classList.remove('active')
                body.classList.remove('scroll-lock')
            } else {
                overlay.classList.add('active')
                body.classList.add('scroll-lock')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .dropdown-menu {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 98;
        transform: translateY(-100%);
        transition: 0.4s ease-in-out;
        opacity: 0;
        overflow: hidden;

        &.active {
            opacity: 1;
            transition: 0.4s ease-in-out;
            transform: translateY(0%);
        }
    }

    .work-container {
        width: 100%;
        height: 100%;
        padding: 5.2rem 1rem 0;
        overflow: scroll;
    }
    .uk-modal-close-full {
       top: 7vw;
       right: 2vw;
       padding: 0;
       color: white;
       background: transparent;
       border: none;
       outline: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/WorkOverlay.vue